import React from 'react'
import '../../../../node_modules/@fortawesome/fontawesome-free/css/all.min.css'
import styled from 'styled-components'

const socialNetworkingIcon = [
  {
    id: 1, type: 1, value: 'fab fa-twitter fa-2x', href: 'https://twitter.com/NickGowdy'
  },
  {
    id: 2, type: 2, value: 'fab fa-instagram fa-2x', href: 'https://www.instagram.com/nickgowdy'
  },
  {
    id: 3, type: 3, value: 'fab fa-linkedin fa-2x', href: 'https://www.linkedin.com/in/nick-gowdy-29443917'
  },
  {
    id: 4, type: 4, value: 'fab fa-github fa-2x', href: 'https://www.github.com/nickgowdy'
  }
]

const socialNetworkingIcons = () => {
  return (
    <div style={styles.socialNetworkingHeader}> {
      socialNetworkingIcon.map((icon) => {
        return (
          <StyledLink style={styles.anchor} target='_blank' href={icon.href} className={icon.class}>
            <i className={icon.value} />
          </StyledLink>
        )
      })
    }
    </div>
  )
}

const styles = {
  socialNetworkingHeader: {
    float: 'right',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    top: 0,
    left: 0,
    height: '48px',
    paddingTop: '5px'
  }
}

const StyledLink = styled.a`
padding: 7px 8px 2px 2px;
color:black;
&:hover {
  color: white;
}
`

export default socialNetworkingIcons
